import { Link } from "react-router-dom"

//Components
import { DashboardWrapper } from "../../layout/dashboardWrapper"
import { DashboardUserDetailsMainSection } from "../../components/dashboard-user-details-main-section"
import { Button } from "../../components/button"

//Styles
import { StyledUserDetailsHeader, StyledButtonContainer, StyledUserDetailsTopSection, StyledUserDetailsTopSectionTabs, StyledUserDetailsTopSectionTab, StyledBackToUers } from '../../styles/users'

//Icons
import { AiOutlineUser } from 'react-icons/ai'
import { FaRegStar, FaStar } from 'react-icons/fa'
import { BsArrowLeft } from 'react-icons/bs'

const DashboardUserDetails = () => {
    return (
        <DashboardWrapper>
            <Link to="/dashboard/users">
                <StyledBackToUers className="back-to-users">
                    <BsArrowLeft size={20} /> <span>Back to Users</span>
                </StyledBackToUers>
            </Link>
            <StyledUserDetailsHeader>

                <h2 className="main-header">User Details</h2>

                <StyledButtonContainer>
                    <Button variant="outline-red" size="small">
                        Blacklist User
                    </Button>
                    <Button variant="outline-primary" size="small">
                        Activate User
                    </Button>
                </StyledButtonContainer>
            </StyledUserDetailsHeader>
            <StyledUserDetailsTopSection>
                <div className="general-details">
                    <div className="user-details">
                        <div className="avatar">
                            <AiOutlineUser size={40} />
                        </div>
                        <div className="personal-info">
                            <h2 className="user-name">Grace Effiom</h2>
                            <p className="user-id">LSQFf587g90</p>
                        </div>
                    </div>
                    <hr className="border" />
                    <div className="user-tier-details">
                        <p>User’s Tier</p>
                        <div className="ratings">
                            <FaStar /> <FaRegStar /> <FaRegStar />
                        </div>
                    </div>
                    <hr className="border" />
                    <div className="user-account-details">
                        <h2>₦200,000.00</h2>
                        <p>9912345678/Providus Bank</p>
                    </div>
                </div>
                <StyledUserDetailsTopSectionTabs>
                    <StyledUserDetailsTopSectionTab active>General Details</StyledUserDetailsTopSectionTab>
                    <StyledUserDetailsTopSectionTab>Documents</StyledUserDetailsTopSectionTab>
                    <StyledUserDetailsTopSectionTab>Bank Details</StyledUserDetailsTopSectionTab>
                    <StyledUserDetailsTopSectionTab>Loans</StyledUserDetailsTopSectionTab>
                    <StyledUserDetailsTopSectionTab>Savings</StyledUserDetailsTopSectionTab>
                    <StyledUserDetailsTopSectionTab>App and System</StyledUserDetailsTopSectionTab>
                </StyledUserDetailsTopSectionTabs>
            </StyledUserDetailsTopSection>
            <DashboardUserDetailsMainSection />
        </DashboardWrapper>
    )
}

export default DashboardUserDetails